import { createFileRoute } from '@tanstack/react-router';
import {
  BiggestWins,
  HomeBannerHero,
  HomeLiveCasino,
  HomeMainMenu,
  HomePopularGames,
  HomeTopEvents,
  LatestWins,
  PromotionEventBanner,
} from '@/ui';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <div className="flex flex-col gap-4">
      <HomeBannerHero />
      <HomeMainMenu />
      <HomeTopEvents />
      <BiggestWins />
      <PromotionEventBanner />
      <LatestWins />
      <HomePopularGames />
      <HomeLiveCasino />
    </div>
  );
}
